import React from "react";
import { useSelector } from "react-redux";
import Navbar from "../../components/Navbar";
import { useGetAssignmentMarksQuery } from "../../features/assignmentMark/assignmentMarkApi";
import { useGetQuizMarksQuery } from "../../features/quizMark/quizMarkApi";
import { useGetUsersQuery } from "../../features/users/userApi";

const Leaderboard = () => {
  const { user } = useSelector((state) => state.auth);
  const { data: assMark } = useGetAssignmentMarksQuery();
  const { data: quizMark } = useGetQuizMarksQuery();

  const { data: users } = useGetUsersQuery();

  const leaderboard = users?.map((user) => {
    const getallQuizMarks = quizMark?.filter(
      (item) => item.student_id === user.id
    );

    const getallAssMarks = assMark?.filter(
      (item) => item.student_id === user.id
    );

    const totalQuizMarks = getallQuizMarks?.reduce(
      (acc, item) => acc + item.totalMark,
      0
    );
    const totalAssMarks = getallAssMarks?.reduce(
      (acc, item) => acc + item.mark,
      0
    );
    const totalMarks = totalQuizMarks + totalAssMarks;
    return {
      ...user,
      totalMarks,
      totalQuizMarks,
      totalAssMarks,
    };
  });

  const sortedLeaderboard = leaderboard?.sort(
    (a, b) => b.totalMarks - a.totalMarks
  );

  const currentUser = sortedLeaderboard?.find((item) => item.id === user.id);
  const currentUserIndex = sortedLeaderboard?.findIndex(
    (item) => item.id === user.id
  );

  if (!sortedLeaderboard) return <div>Loading...</div>;
  
  sortedLeaderboard.length = 20;

  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div>
            <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
            <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
              <thead>
                <tr>
                  <th className="table-th !text-center">Rank</th>
                  <th className="table-th !text-center">Name</th>
                  <th className="table-th !text-center">Quiz Mark</th>
                  <th className="table-th !text-center">Assignment Mark</th>
                  <th className="table-th !text-center">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-2 border-cyan">
                  <td className="table-td text-center font-bold">
                    {1 + currentUserIndex}
                  </td>
                  <td className="table-td text-center font-bold">
                    {currentUser?.name}
                  </td>
                  <td className="table-td text-center">
                    {currentUser?.totalQuizMarks}
                  </td>
                  <td className="table-td text-center">
                    {currentUser?.totalAssMarks}
                  </td>
                  <td className="table-td text-center">
                    {currentUser?.totalMarks}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="my-8">
            <h3 className="text-lg font-bold">Top 20 Result</h3>
            <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
              <thead>
                <tr className="border-b border-slate-600/50">
                  <th className="table-th !text-center">Rank</th>
                  <th className="table-th !text-center">Name</th>
                  <th className="table-th !text-center">Quiz Mark</th>
                  <th className="table-th !text-center">Assignment Mark</th>
                  <th className="table-th !text-center">Total</th>
                </tr>
              </thead>
              <tbody>
                {sortedLeaderboard?.map((item, index) => (
                  <tr className="border-b border-slate-600/50" key={item.id}>
                    <td className="table-td text-center">{++index}</td>
                    <td className="table-td text-center">{item.name}</td>
                    <td className="table-td text-center">
                      {item.totalQuizMarks}
                    </td>
                    <td className="table-td text-center">
                      {item.totalAssMarks}
                    </td>
                    <td className="table-td text-center">{item.totalMarks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </>
  );
};

export default Leaderboard;
